import { Color, Icon, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { SimpleCheckListAlignment } from './types/SimpleCheckListAlignment'

interface SimpleChecklistWrapperProps {
  grid?: boolean
  alignment?: SimpleCheckListAlignment
}

export const SimpleChecklistWrapper = styled.div<SimpleChecklistWrapperProps>`
  margin-right: auto;
  margin-left: ${({ alignment }) => (alignment === 'left' ? 0 : 'auto')};
  ${({ grid }) => {
    if (grid) {
      return `
      display: grid;
      grid-template-columns: 250px 1fr;
    `
    }
  }};
`

interface ListItemProps {
  condensed?: boolean
}

export const ListItem = styled.div<ListItemProps>`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${({ condensed }) => (condensed ? Spacing.S8 : Spacing.S12)};
`

export const ListIcon = styled(Icon)`
  flex-shrink: 0;
  margin-top: ${Spacing.S2};
  margin-right: ${Spacing.S8};
  padding: ${Spacing.S2};
  border-radius: 50%;
  background-color: ${Color.Lavender500};
`

export const FlatListIcon = styled.div`
  flex-shrink: 0;
  margin-top: ${Spacing.S2};
  margin-right: ${Spacing.S8};
`
